/**
 * Chiede al service worker (dalla v18) di scaricare i pezzi della build che
 * gli mancano: le pagine si caricano a pezzi, e offline servono tutti. Lo
 * si chiede qualche secondo dopo l'apertura, per non rubare banda alla
 * prima schermata, e quando torna la rete. Un worker vecchio lo ignora.
 */
const BUILD_SYNC_DELAY_MS = 6000;
let buildSyncScheduled = false;

/** Cerca la versione nuova; offline fallisce, e va bene così (niente errori non gestiti). */
const checkForUpdate = (registration: ServiceWorkerRegistration) => {
  registration.update().catch(() => { /* offline o server irraggiungibile: al prossimo giro */ });
};

export function requestBuildSync() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => {
      if (registration.active) registration.active.postMessage({ type: 'SYNC_BUILD' });
    })
    .catch(() => { /* niente worker: niente da fare */ });
}

function scheduleBuildSync() {
  if (buildSyncScheduled) return;
  buildSyncScheduled = true;
  setTimeout(requestBuildSync, BUILD_SYNC_DELAY_MS);
  window.addEventListener('online', requestBuildSync);
}

export function register() {
  if ('serviceWorker' in navigator) {
    scheduleBuildSync();

    // Attendi che la finestra sia completamente caricata
    window.addEventListener('load', () => {
      const swUrl = '/pwa-worker.js';

      // Registra il PWA worker con scope esplicito
      navigator.serviceWorker
        .register(swUrl, {
          scope: '/',
          updateViaCache: 'none' // Forza il controllo degli aggiornamenti
        })
        .then(registration => {
          // Controllo immediato per aggiornamenti
          checkForUpdate(registration);

          // Controllo periodico ogni ora invece che 24 ore per maggiore reattività
          setInterval(() => {
            checkForUpdate(registration);
          }, 1000 * 60 * 60);

          // L'attivazione della versione nuova (e il reload) la gestisce
          // index.tsx nei momenti in cui non disturba: qui si cerca soltanto.
        })
        .catch(error => {
          console.error('Service worker registration failed:', error);
        });

      // Registrazione OneSignal
      navigator.serviceWorker
        .register('/push/onesignal/OneSignalSDKWorker.js', {
          scope: '/push/onesignal/'
        })
        .catch(error => {
          console.error('OneSignal SW registration failed:', error);
        });
    });

    // Aggiornamento più frequente quando l'app torna in primo piano
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        navigator.serviceWorker.ready.then(checkForUpdate);
      }
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then(registration => {
        registration.unregister();
      })
      .catch(error => {
        console.error('Service worker unregistration failed:', error);
      });
  }
}
